<template>
    <div class="inline-flex flex-col items-center gap-1">
        <canvas ref="canvasEl" />
        <div class="text-sm font-semibold">{{ label }}</div>
        <div
            v-if="subtitle"
            class="text-xs text-gray-500"
            :class="{ 'print:hidden': hideSubtitleInPrint }"
        >
            {{ subtitle }}
        </div>
        <div v-if="showRaw" class="text-xs font-mono text-gray-400 break-all max-w-[16rem]">{{ code }}</div>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch, onMounted } from 'vue'
    import QRCode from 'qrcode'

    const props = defineProps<{
        code: string
        label: string
        subtitle?: string
        size?: number
        showRaw?: boolean
        // Hide the subtitle line in print media — used by the clipboard print
        // sheet where only the label is meant to appear above each QR.
        hideSubtitleInPrint?: boolean
    }>()

    const canvasEl = ref<HTMLCanvasElement | null>(null)

    async function render() {
        if (!canvasEl.value || !props.code) return
        await QRCode.toCanvas(canvasEl.value, props.code, { width: props.size ?? 200 })
    }

    onMounted(render)
    watch(() => [props.code, props.size], render)
</script>
